module.exports = __webpack_public_path__ + "img/huddle-pop@3x.png";